import { atom } from 'recoil'

export default atom({key: 'news', default: {
  showFiexdCategory: false
}})